<template>
  <div class="c-thumbnail" :class="{ 'wrapper-2': srcs.length % 2 === 0 && srcs.length < 5, 'wrapper-1': srcs.length === 1 }">
    <img class="c-thumbnail-item" :src="item.src" v-for="item in srcArrays" :key="item.key" @click.stop="handlePreview(srcs, item.src)" />
  </div>
</template>
<script>
import { ImagePreview } from 'vant';
export default {
  props: {
    srcs: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    srcArrays() {
      return this.srcs.map((src) => ({ src, key: new Date().getTime() + Math.random() }));
    },
  },
  methods: {
    handlePreview(images, image) {
      const startPosition = images.findIndex((url) => url === image);
      ImagePreview({ images, startPosition });
    },
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {},
};
</script>
<style lang="scss" scoped>
.c-thumbnail {
  :deep() {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 0 0 0;
    margin-bottom: -8px;
    background-color: #ffffff;
    .c-thumbnail-item {
      margin-right: 8px;
      margin-bottom: 8px;
      width: 108px;
      height: 108px;
      border-radius: 8px;
      object-fit: cover;
      &:nth-of-type(3n) {
        margin-right: 0;
      }
    }

    &.wrapper-1 {
      .c-thumbnail-item {
        margin-right: 0;
        width: 100%;
        height: 185px;
      }
    }
    &.wrapper-2 {
      width: 230px;
      .c-thumbnail-item {
        // width: 168px;
        // height: 168px;
        &:nth-of-type(3n) {
          margin-right: 8px;
        }
        &:nth-of-type(2n) {
          margin-right: 0;
        }
      }
    }
  }
  &.wrapper-2 :deep() {
    width: 230px;
    .c-thumbnail-item {
      // width: 168px;
      // height: 168px;
      &:nth-of-type(3n) {
        margin-right: 8px;
      }
      &:nth-of-type(2n) {
        margin-right: 0;
      }
    }
  }
  &.wrapper-1 :deep() {
    .c-thumbnail-item {
      margin-right: 0;
      width: 100%;
      height: 185px;
    }
  }
}
</style>
